"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
/**
 * @author Guo Yunhe <guoyunhebrave(a)gmail.com>
 */
var React = require("react");
var classNames = require("classnames");
var Collapse = /** @class */ (function (_super) {
    __extends(Collapse, _super);
    function Collapse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Collapse.prototype.componentDidMount = function () {
        if (this.props.collapsed) {
            this.root.style.height = '0';
            this.root.style.overflow = 'hidden';
        }
    };
    Collapse.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (this.props.collapsed !== nextProps.collapsed) {
            if (nextProps.collapsed) {
                // Here I have to write it twice to make it work. Cannot figure out why.
                // -2 are for the -1px top and bottom margin of inner. See index.scss
                // for reason.
                this.root.style.height =
                    this.inner.getBoundingClientRect().height - 2 + 'px';
                this.root.style.height =
                    this.inner.getBoundingClientRect().height - 2 + 'px';
                this.root.style.height = '0';
                this.root.style.overflow = 'hidden';
            }
            else {
                this.root.style.height =
                    this.inner.getBoundingClientRect().height - 2 + 'px';
                setTimeout(function () {
                    _this.root.style.height = 'unset'; // Now you don't need manual height
                    _this.root.style.overflow = 'unset'; // Now you don't need overflow hidden
                }, 300); // This time must be the same as CSS transition duration
            }
        }
    };
    Collapse.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, collapsed = _a.collapsed, rest = __rest(_a, ["children", "className", "collapsed"]);
        return (React.createElement("div", __assign({}, rest, { className: classNames('sok-collapse', this.props.className), ref: function (e) {
                _this.root = e;
            } }),
            React.createElement("div", { className: "sok-collapse-inner", ref: function (e) {
                    _this.inner = e;
                } }, children)));
    };
    return Collapse;
}(React.Component));
exports.Collapse = Collapse;
//# sourceMappingURL=index.js.map